<template>
  <div class="container-page">
    <div class="create-projects">
      <!-- title -->
      <h2 class="create-projects__title title-inner">
        {{ projectId == 0 ? 'Создание нового проекта МПК' : 'Редактирование карточки проекта МПК' }}
      </h2>

      <Loader v-if="isLoading" class="loader" />

      <div v-else>
        <div v-if="!isProjectFromEnd" class="create-projects__row create-projects__row--start">
          <div class="w-100 required create-projects__wrapper-col--mt-25">
            <p class="create-projects__label required">Название проекта</p>
            <ComponentInput required v-model="item.name" mod="redesigned" placeholder="Введите название" />
          </div>

          <div class="w-100">
            <p class="create-projects__label required">Страна реализации инвестиционного проекта</p>
            <SelectMultiComponentCheckbox
              placeholder="Выберите страну"
              :options="countries"
              v-model="projectListCountries"
              trackBy="text"
              valueProp="id"
              labelOptions="text"
              required
            />
          </div>
        </div>

        <div v-if="!isProjectFromEnd" class="create-projects__row create-projects__row--start">
          <div class="w-100">
            <p class="create-projects__label required">Cтрана-партнер</p>
            <SelectSingleComponentCheckbox
              placeholder="Выберите страну"
              :options="countries"
              v-model="item.partnerCountryId"
              trackBy="text"
              valueProp="id"
              labelOptions="text"
              required
            />
          </div>
          <div class="w-100">
            <p class="create-projects__label required">Цели проекта</p>
            <SelectMultiComponentCheckbox
              placeholder="Выберите цели проекта"
              :options="purposes"
              v-model="projectPurposes"
              trackBy="text"
              valueProp="id"
              labelOptions="text"
              required
            />
          </div>
        </div>

        <div v-if="!isProjectFromEnd" class="create-projects__row create-projects__row--start">
          <div class="w-100 create-projects__wrapper-col--mt-25">
            <p class="create-projects__label required">Статус инвестиционного проекта</p>
            <SelectSingleComponentCheckbox
              placeholder="Выберите статус"
              :options="statuses"
              v-model="item.statusId"
              trackBy="text"
              valueProp="id"
              labelOptions="text"
              required
            />
          </div>

          <div v-if="!isProjectFromEnd" class="w-100">
            <p class="create-projects__label required">Отрасль</p>
            <SelectSingleComponentCheckbox
              placeholder="Выберите отрасль"
              :options="industries"
              v-model="item.industryId"
              trackBy="text"
              valueProp="id"
              labelOptions="text"
              required
            />
          </div>
        </div>

        <div class="create-projects__row create-projects__row--start">
          <div class="create-projects__wrapper-col--50">
            <p class="create-projects__label">МПК</p>
            <SelectSingleComponentCheckbox
              placeholder="Выберите МПК"
              :options="mpkCommission"
              v-model="item.mpkComissionId"
              trackBy="text"
              valueProp="id"
              labelOptions="text"
            />
          </div>
        </div>

        <hr v-if="!isProjectFromEnd" />
        <h3 v-if="!isProjectFromEnd" class="title-inputBlock create-projects__block-title">Участники</h3>

        <div class="create-projects__row create-projects__row--start">
          <div v-if="!isProjectFromEnd" class="w-100">
            <p class="create-projects__label required">Организация, реализующая проект/SPV</p>
            <ComponentInput
              v-model="item.organizationImplementingProject"
              required
              mod="redesigned"
              placeholder="Введите организацию"
            />
          </div>
          <div class="w-100">
            <p class="create-projects__label required">Описание проекта</p>
            <ComponentInput
              v-model="item.description"
              type="textarea"
              modClass="redesigned"
              required
              placeholder="Введите описание проекта"
            />
          </div>
        </div>

        <hr v-if="!isProjectFromEnd" />
        <h3 v-if="!isProjectFromEnd" class="title-inputBlock create-projects__block-title">Период реализации</h3>
        <div v-if="!isProjectFromEnd" class="create-projects__row create-projects__row--start">
          <div class="w-100">
            <p class="create-projects__label required">Плановый год начала реализации инвестиционной стадии проекта</p>
            <DateComponent
              v-model="plannedYearStartInvStage"
              mode="year"
              :clearable="false"
              :typeable="false"
              modClass="redesigned"
              dateIcon
              required
            />
          </div>

          <div class="w-100">
            <p class="create-projects__label required">
              Плановый год окончания реализации инвестиционной стадии проекта
            </p>
            <DateComponent
              v-model="plannedYearEndInvStage"
              mode="year"
              :clearable="false"
              :typeable="false"
              modClass="redesigned"
              dateIcon
              required
            />
          </div>
        </div>

        <!-- Ход реализации -->

        <hr v-if="!isProjectFromEnd" />
        <h3 v-if="!isProjectFromEnd" class="title-inputBlock create-projects__block-title">Ход реализации проекта</h3>
        <h4 v-if="!isProjectFromEnd" class="title-inputBlock create-projects__block-subtitle">Параметры</h4>

        <div v-if="!isProjectFromEnd" class="create-projects__row create-projects__row--start">
          <div class="w-100">
            <div class="create-projects__label-wrapper">
              <p class="create-projects__label required">Общий объем инвестиций, млрд руб.</p>
              <SumTooltip />
            </div>
            <ComponentInput
              v-model="item.totalInvestmentMlrdRub"
              mod="redesigned"
              placeholder="Введите объем инвестиций"
              required
              type="number"
              :min="0"
            />
          </div>
          <div class="w-100">
            <p class="create-projects__label required">Общий объем инвестиций, тыс. долларов</p>
            <ComponentInput
              v-model="item.totalInvestmentThousDol"
              mod="redesigned"
              placeholder="Введите объем инвестиций"
              required
              type="number"
              :min="0"
            />
          </div>
        </div>
        <div v-if="!isProjectFromEnd" class="create-projects__row create-projects__params">
          <div class="create-projects__wrapper-col--70">
            <p class="create-projects__label">ФОИВ-куратор</p>
            <SelectSingleComponentCheckbox
              placeholder="Выберите куратора"
              :options="foivs"
              v-model="item.foivCuratorId"
              trackBy="text"
              valueProp="id"
              labelOptions="text"
            />
          </div>
        </div>

        <h4 v-if="!isProjectFromEnd" class="title-inputBlock create-projects__block-subtitle">
          Дополнительные параметры
        </h4>

        <div class="create-projects__row create-projects__row--start">
          <div class="create-projects__wrapper-col--70">
            <p class="create-projects__label required">Постоянные новые рабочие места, чел.</p>
            <ComponentInput
              v-model="item.constantNewJobs"
              mod="redesigned"
              required
              type="number"
              :min="0"
              placeholder="Введите количество рабочих мест"
            />
          </div>
        </div>

        <div class="create-projects__row">
          <div class="create-projects__wrapper-col--70">
            <p class="create-projects__label">
              Субъект Российской Федерации, в котором будет реализован инвестиционный проект
            </p>
            <SelectSingleComponentCheckbox
              placeholder="Выберите регион"
              :options="russianRegions"
              v-model="item.regionOfRussiaId"
              trackBy="text"
              valueProp="id"
              labelOptions="text"
              :disabled="!isRussia"
            />
          </div>
        </div>
        <div class="create-projects__row">
          <div class="create-projects__wrapper-col--70">
            <p class="create-projects__label">
              Регион Китайской Народной Республики, в котором будет реализован инвестиционный проект
            </p>
            <SelectSingleComponentCheckbox
              placeholder="Выберите регион"
              :options="chinaRegions"
              v-model="item.regionOfChinaId"
              trackBy="text"
              valueProp="id"
              labelOptions="text"
              :disabled="!isChina"
            />
          </div>
        </div>

        <div class="create-projects__row">
          <div class="create-projects__wrapper-col--70">
            <p class="create-projects__label required">Курирующий заместитель Министра</p>
            <ComponentInput
              v-model="item.supervisingMinister"
              mod="redesigned"
              required
              placeholder="Введите имя заместителя"
            />
          </div>
        </div>

        <div class="create-projects__row create-projects__row--start">
          <div class="w-100">
            <p class="create-projects__label required">Ответственный департамент МЭР</p>
            <SelectSingleComponentCheckbox
              placeholder="Выберите департамент"
              v-model="item.departmentId"
              :options="getMpkProjectDepartments"
              trackBy="text"
              valueProp="id"
              labelOptions="text"
              required
            />
          </div>
          <div class="w-100">
            <p class="create-projects__label required">Степень участия МЭР в проекте</p>
            <SelectSingleComponentCheckbox
              placeholder="Выберите степень участия"
              v-model="item.minRoleId"
              :options="getMpkProjectMinRoles"
              trackBy="text"
              valueProp="id"
              labelOptions="text"
              required
            />
          </div>
        </div>

        <div class="create-projects__row create-projects__row--start">
          <div class="create-projects__wrapper-col--70">
            <p class="create-projects__label required">Меры поддержки</p>
            <SelectSingleComponentCheckbox
              placeholder="Выберите меру поддержки"
              v-model="item.supportMeasureId"
              :options="getMpkProjectSupportMeasures"
              trackBy="text"
              valueProp="id"
              labelOptions="text"
              required
            />
          </div>
        </div>

        <div class="create-projects__row">
          <div class="create-projects__wrapper-col--70">
            <p class="create-projects__label required">
              Наименование меры поддержки, в рамках которой ведется учет инвестиционных проектов
            </p>
            <SelectSingleComponentCheckbox
              placeholder="Введите наименование меры поддержки"
              v-model="item.projectCategoryId"
              :options="getMpkProjectCategories"
              trackBy="text"
              valueProp="id"
              labelOptions="text"
              required
            />
          </div>
        </div>

        <div class="create-projects__row">
          <div class="w-100" v-if="!isProjectFromEnd">
            <p class="create-projects__label required">Проблема</p>
            <ComponentInput
              v-model="item.problems"
              type="textarea"
              mod="redesigned"
              required
              placeholder="Введите проблему"
            />
          </div>
        </div>
        <div class="create-projects__row">
          <div class="w-100">
            <p class="create-projects__label required">Дата подписания</p>
            <DateComponent v-model="item.signatureDate" :clearable="false" modClass="redesigned" dateIcon />
          </div>

          <div class="w-100 checkboxInput">
            <input v-model="item.isCrossBorderProject" type="checkbox" id="isCrossBorder" />
            <label for="isCrossBorder" class="create-projects__label">Трансграничный проект</label>
          </div>
        </div>

        <!-- Дополнительный блок -->

        <div class="create-projects__row">
          <ButtonComponent mod="more-big" @click="onShowMore">
            {{ showMore ? 'Скрыть' : 'Дополнительно' }}
            <IconComponent v-if="showMore" class="icon--full-svg icon--hide-rating" name="arrowCurrentColor" />
            <IconComponent v-else class="icon--full-svg" name="plus-mini" />
          </ButtonComponent>
        </div>

        <div v-show="showMore">
          <div v-if="!isProjectFromEnd" class="create-projects__row">
            <div class="w-100">
              <p class="create-projects__label">Дата внесения информации о статусе проекта</p>
              <DateComponent v-model="item.dateProjectStatus" :clearable="false" modClass="redesigned" dateIcon />
            </div>
            <div class="w-100">
              <p class="create-projects__label">Перечень создаваемых объектов</p>
              <ComponentInput v-model="item.createdObjectsList" mod="redesigned" placeholder="Введите название" />
            </div>
          </div>

          <div v-if="!isProjectFromEnd" class="create-projects__row create-projects__row--start">
            <div class="w-100">
              <p class="create-projects__label">Перечень создаваемых объектов, наименование</p>
              <ComponentInput
                v-model="item.createdObjectListName"
                mod="redesigned"
                placeholder="Введите наименование"
              />
            </div>
            <div class="w-100">
              <p class="create-projects__label">Перечень проекта</p>
              <SelectSingleComponentCheckbox
                placeholder="Выберите перечень проекта"
                :options="getMpkListProjects"
                v-model="item.projectListId"
                trackBy="text"
                valueProp="id"
                labelOptions="text"
              />
            </div>
          </div>

          <div v-if="!isProjectFromEnd" class="create-projects__row create-projects__row--start">
            <div class="w-100">
              <p class="create-projects__label">Инициатор проекта (головная организация)</p>
              <ComponentInput v-model="item.initiator" mod="redesigned" placeholder="Введите инициатора проекта" />
            </div>
            <div class="w-100">
              <p class="create-projects__label">ИНН организации, реализующей проект</p>
              <ComponentInput v-model="item.innOrganization" mod="redesigned" placeholder="Введите ИНН" />
            </div>
          </div>

          <div v-if="!isProjectFromEnd" class="create-projects__row create-projects__row--start">
            <div class="w-100">
              <div class="create-projects__label-wrapper">
                <p class="create-projects__label">Общий объем инвестиций, млрд руб. (не распределено)</p>
                <SumTooltip />
              </div>

              <ComponentInput
                v-model="item.totalInvestmentMlrdRubNotDistributed"
                mod="redesigned"
                placeholder="Введите объем инвестиций"
                type="number"
                :min="0"
              />
            </div>
          </div>

          <div class="create-projects__row create-projects__row--start">
            <div class="w-100">
              <p class="create-projects__label">Конечный бенефициар инвестпроекта</p>
              <ComponentInput
                v-model="item.finalBeneficiary"
                mod="redesigned"
                placeholder="Введите конечного бенефициара"
              />
            </div>
          </div>

          <div v-if="!isProjectFromEnd" class="create-projects__add-params">
            <div class="create-projects__row create-projects__row--start">
              <div class="w-100">
                <p class="create-projects__label">Временные новые рабочие места, чел</p>
                <ComponentInput
                  v-model="item.temporaryNewJobs"
                  mod="redesigned"
                  type="number"
                  :min="0"
                  placeholder="Введите количество рабочих мест"
                />
              </div>
            </div>

            <div class="create-projects__row create-projects__OKVED">
              <div class="w-100">
                <p class="create-projects__label">Раздел ОКВЭД</p>
                <ComponentInput v-model="item.nsiOkvedSection" mod="redesigned" placeholder="Введите раздел" />
              </div>
              <div class="create-projects__wrapper-col--50">
                <p class="create-projects__label">Группа ОКВЭД</p>
                <ComponentInput v-model="item.nsiOkvedGroup" mod="redesigned" placeholder="Введите группу" />
              </div>
              <div class="create-projects__wrapper-col--50">
                <p class="create-projects__label">Код ОКВЭД</p>
                <ComponentInput v-model="item.nsiCodeOkved" mod="redesigned" placeholder="Введите код" />
              </div>
            </div>

            <div class="create-projects__row create-projects__row--start">
              <div class="w-100">
                <p class="create-projects__label">Иная степень участия МЭР в проекте</p>
                <ComponentInput
                  v-model="item.minRoleOther"
                  mod="redesigned"
                  placeholder="Введите иную степень участия"
                />
              </div>
            </div>

            <div class="create-projects__row">
              <div class="create-projects__wrapper-col--50">
                <p class="create-projects__label">Сайт компании</p>
                <ComponentInput v-model="item.webSite" mod="redesigned" placeholder="Введите сайт" />
              </div>
            </div>

            <div class="create-projects__row">
              <div class="w-100">
                <p class="create-projects__label">Плановый год начала эксплуатационной стадии проекта</p>
                <DateComponent
                  v-model="plannedYearStartOpStage"
                  mode="year"
                  :typeable="false"
                  modClass="redesigned"
                  dateIcon
                />
              </div>
              <div class="w-100">
                <p class="create-projects__label">Плановый год выхода на проектную мощность</p>
                <DateComponent
                  v-model="plannedYearDesignCapacity"
                  mode="year"
                  :typeable="false"
                  modClass="redesigned"
                  dateIcon
                />
              </div>
            </div>

            <div class="create-projects__row">
              <div class="w-100">
                <div class="create-projects__label-wrapper">
                  <p class="create-projects__label">Чистая приведенная стоимость (NPV), млрд руб.</p>
                  <SumTooltip />
                </div>
                <ComponentInput
                  v-model="item.npvValue"
                  mod="redesigned"
                  type="number"
                  :min="0"
                  placeholder="Введите NPV"
                />
              </div>
              <div class="w-100">
                <p class="create-projects__label">Внутренняя норма окупаемости (IRR), %</p>
                <ComponentInput
                  v-model="item.irrValue"
                  mod="redesigned"
                  type="number"
                  :min="0"
                  placeholder="Введите IRR"
                />
              </div>
            </div>

            <div class="create-projects__row">
              <div class="create-projects__wrapper-col--50">
                <p class="create-projects__label">Срок реализации инвестиционной фазы, лет</p>
                <ComponentInput
                  v-model="item.implementationPeriodInvestmentPhase"
                  mod="redesigned"
                  type="number"
                  :min="0"
                  placeholder="Введите срок реализации"
                />
              </div>
            </div>

            <div class="create-projects__row">
              <div class="create-projects__wrapper-col--70">
                <p class="create-projects__label">
                  Наименование иной меры поддержки, в рамках которой ведется учет инвестиционных проектов
                </p>
                <ComponentInput
                  v-model="item.otherProjectCateogory"
                  mod="redesigned"
                  placeholder="Введите наименование иной меры поддержки"
                />
              </div>
            </div>
            <div class="create-projects__row">
              <div class="create-projects__wrapper-col--70">
                <p class="create-projects__label">Курс ЦБ на дату заключения контракта</p>
                <ComponentInput
                  v-model="item.centralBankExchangeRate"
                  mod="redesigned"
                  type="number"
                  :min="0"
                  placeholder="Введите курс ЦБ"
                />
              </div>
            </div>
            <div class="create-projects__row">
              <CheckboxInput v-model="item.notSpecifiedFundingFlag" label="Могу указать структуру финансирования" />
            </div>
            <div class="create-projects__row create-projects__row--start">
              <div class="w-100 budget-funding-col--mt-25">
                <div class="create-projects__label-wrapper">
                  <p class="create-projects__label" :class="{ required: item.notSpecifiedFundingFlag }">
                    Бюджетное финансирование, млрд руб.
                  </p>
                  <SumTooltip />
                </div>
                <ComponentInput
                  placeholder="Укажите финансирование"
                  v-model="item.budgetFunding"
                  mod="redesigned"
                  :required="item.notSpecifiedFundingFlag"
                  type="number"
                  :min="0"
                />
              </div>
              <div class="w-100">
                <div class="create-projects__label-wrapper">
                  <p class="create-projects__label" :class="{ required: item.notSpecifiedFundingFlag }">
                    Финансирование из федерального бюджета (в т. ч. в рамках мер поддержки), млрд руб.
                  </p>
                  <SumTooltip />
                </div>
                <ComponentInput
                  placeholder="Укажите финансирование"
                  v-model="item.federalBudget"
                  mod="redesigned"
                  :required="item.notSpecifiedFundingFlag"
                  type="number"
                  :min="0"
                />
              </div>
            </div>

            <div class="create-projects__row create-projects__row--start">
              <div class="w-100">
                <div class="create-projects__label-wrapper">
                  <p class="create-projects__label" :class="{ required: item.notSpecifiedFundingFlag }">
                    Финансирование из региональных бюджетов (в т. ч. в рамках мер поддержки), млрд руб.
                  </p>
                  <SumTooltip />
                </div>
                <ComponentInput
                  placeholder="Укажите финансирование"
                  v-model="item.regionalBudget"
                  mod="redesigned"
                  :required="item.notSpecifiedFundingFlag"
                  type="number"
                  :min="0"
                />
              </div>
              <div class="w-100">
                <div class="create-projects__label-wrapper">
                  <p class="create-projects__label">
                    Финансирование из муниципальных бюджетов (в т. ч. в рамках мер поддержки), млрд руб.
                  </p>
                  <SumTooltip />
                </div>
                <ComponentInput
                  v-model="item.municipalBudget"
                  mod="redesigned"
                  type="number"
                  :min="0"
                  placeholder="Укажите финансирование"
                />
              </div>
            </div>

            <div class="create-projects__row create-projects__row--start">
              <div class="w-100">
                <div class="create-projects__label-wrapper">
                  <p class="create-projects__label" :class="{ required: item.notSpecifiedFundingFlag }">
                    Собственные средства, млрд руб.
                  </p>
                  <SumTooltip />
                </div>
                <ComponentInput
                  v-model="item.ownBudget"
                  mod="redesigned"
                  :required="item.notSpecifiedFundingFlag"
                  type="number"
                  :min="0"
                  placeholder="Укажите собственные средства"
                />
              </div>
              <div class="w-100">
                <div class="create-projects__label-wrapper">
                  <p class="create-projects__label">Привлеченные средства, млрд руб.</p>
                  <SumTooltip />
                </div>
                <ComponentInput
                  v-model="item.raisedBudget"
                  mod="redesigned"
                  type="number"
                  :min="0"
                  placeholder="Укажите привлеченные средства"
                />
              </div>
            </div>

            <div class="create-projects__row create-projects__row--start">
              <div class="w-100 not-specified-funding-col--mt-25">
                <div class="create-projects__label-wrapper">
                  <p class="create-projects__label" :class="{ required: item.notSpecifiedFundingFlag }">
                    Банковские кредиты (в т. ч. в рамках мер поддержки), млрд руб.
                  </p>
                  <SumTooltip />
                </div>
                <ComponentInput
                  v-model="item.bankLoans"
                  mod="redesigned"
                  :required="item.notSpecifiedFundingFlag"
                  type="number"
                  :min="0"
                  placeholder="Укажите банковские кредиты"
                />
              </div>
              <div class="w-100">
                <div class="create-projects__label-wrapper">
                  <p class="create-projects__label" :class="{ required: item.notSpecifiedFundingFlag }">
                    Иные заемные и привлеченные средства (в т. ч. в рамках мер поддержки), млрд руб.
                  </p>
                  <SumTooltip />
                </div>
                <ComponentInput
                  v-model="item.otherBorrowedFunds"
                  mod="redesigned"
                  :required="item.notSpecifiedFundingFlag"
                  type="number"
                  :min="0"
                  placeholder="Укажите привлеченные средства"
                />
              </div>
            </div>

            <div class="create-projects__row">
              <div class="w-100">
                <p class="create-projects__label">Бюджетное финансирование, тыс. долларов</p>
                <ComponentInput
                  v-model="item.budgetFundingDollars"
                  mod="redesigned"
                  type="number"
                  :min="0"
                  placeholder="Укажите финансирование"
                />
              </div>
              <div class="w-100">
                <p class="create-projects__label">
                  Финансирование из федерального бюджета (в т. ч. в рамках мер поддержки), тыс. долларов
                </p>
                <ComponentInput
                  v-model="item.federalBudgetDollars"
                  mod="redesigned"
                  type="number"
                  placeholder="Укажите финансирование"
                />
              </div>
            </div>

            <div class="create-projects__row">
              <div class="w-100">
                <p class="create-projects__label">
                  Финансирование из региональных бюджетов (в т. ч. в рамках мер поддержки), тыс. долларов
                </p>
                <ComponentInput
                  v-model="item.regionalBudgetDollars"
                  mod="redesigned"
                  type="number"
                  :min="0"
                  placeholder="Укажите финансирование"
                />
              </div>
              <div class="w-100">
                <p class="create-projects__label">
                  Финансирование из муниципальных бюджетов (в т. ч. в рамках мер поддержки), тыс. долларов
                </p>
                <ComponentInput
                  v-model="item.municipalBudgetDollars"
                  mod="redesigned"
                  type="number"
                  placeholder="Укажите финансирование"
                />
              </div>
            </div>

            <div class="create-projects__row">
              <div class="w-100">
                <p class="create-projects__label">Собственные средства, тыс. долларов</p>
                <ComponentInput
                  v-model="item.ownBudgetDollars"
                  mod="redesigned"
                  type="number"
                  :min="0"
                  placeholder="Укажите собственные средства"
                />
              </div>
              <div class="w-100">
                <p class="create-projects__label">Привлеченные средства, тыс. долларов</p>
                <ComponentInput
                  v-model="item.raisedBudgetDollars"
                  mod="redesigned"
                  type="number"
                  placeholder="Укажите привлеченные средства"
                />
              </div>
            </div>

            <div class="create-projects__row">
              <div class="w-100">
                <p class="create-projects__label">Банковские кредиты (в т. ч. в рамках мер поддержки), тыс. долларов</p>
                <ComponentInput
                  v-model="item.bankLoansDollars"
                  mod="redesigned"
                  type="number"
                  :min="0"
                  placeholder="Укажите банковские кредиты"
                />
              </div>
              <div class="w-100">
                <p class="create-projects__label">
                  Иные заемные и привлеченные средства (в т. ч. в рамках мер поддержки), тыс. долларов
                </p>
                <ComponentInput
                  v-model="item.otherBorrowedFundsDollars"
                  mod="redesigned"
                  type="number"
                  placeholder="Укажите привлеченные средства"
                />
              </div>
            </div>

            <div class="create-projects__row">
              <div class="create-projects__wrapper-col--70">
                <div class="create-projects__label-wrapper">
                  <p class="create-projects__label">Объем проинвестированных средств, млрд руб.</p>
                  <SumTooltip />
                </div>
                <ComponentInput
                  v-model="item.volumeOfInvestedFunds"
                  mod="redesigned"
                  type="number"
                  :min="0"
                  placeholder="Укажите объем проинвестированных средств"
                />
              </div>
            </div>
            <div class="create-projects__row">
              <div class="create-projects__wrapper-col--50">
                <p class="create-projects__label">Дата внесения информации об объеме инвестиций</p>
                <DateComponent
                  v-model="item.dateEnteringInfoOnVolumeInvestments"
                  :clearable="false"
                  modClass="redesigned"
                  dateIcon
                />
              </div>
            </div>
            <div class="create-projects__row">
              <div class="w-100">
                <div class="create-projects__label-wrapper">
                  <p class="create-projects__label">Среднегодовой объем чистой прибыли, млрд руб</p>
                  <SumTooltip />
                </div>
                <ComponentInput
                  v-model="item.averageAnnualNetProfit"
                  mod="redesigned"
                  type="number"
                  :min="0"
                  placeholder="Введите объем чистой прибыли"
                />
              </div>
              <div class="w-100">
                <div class="create-projects__label-wrapper">
                  <p class="create-projects__label">
                    Среднегодовая выручка после выхода на проектную мощность, млрд руб.
                  </p>
                  <SumTooltip />
                </div>
                <ComponentInput
                  v-model="item.averageAnnualRevenueAfterReachingDesignCapacity"
                  mod="redesigned"
                  type="number"
                  :min="0"
                  placeholder="Введите среднегодовую выручку"
                />
              </div>
            </div>
            <div class="create-projects__row">
              <div class="w-100">
                <div class="create-projects__label-wrapper">
                  <p class="create-projects__label">Налоговые выплаты на инвестиционной стадии, млрд руб.</p>
                  <SumTooltip />
                </div>
                <ComponentInput
                  v-model="item.taxPaymentsAtTheInvestmentStage"
                  mod="redesigned"
                  type="number"
                  :min="0"
                  placeholder="Введите налоговые выплаты"
                />
              </div>
              <div class="w-100">
                <div class="create-projects__label-wrapper">
                  <p class="create-projects__label">Налоговые выплаты на эксплуатационной стадии, млрд руб.</p>
                  <SumTooltip />
                </div>
                <ComponentInput
                  v-model="item.taxPaymentsAtTheOperationalStage"
                  mod="redesigned"
                  type="number"
                  :min="0"
                  placeholder="Введите налоговые выплаты"
                />
              </div>
            </div>
            <div class="create-projects__row">
              <div class="create-projects__wrapper-col--70">
                <div class="create-projects__label-wrapper">
                  <p class="create-projects__label">
                    Среднегодовая сумма налоговых выплат после выхода на проектную мощность, млрд руб.
                  </p>
                  <SumTooltip />
                </div>
                <ComponentInput
                  v-model="item.averageAnnualAmountOfTaxPaymentsAfterReachingDesignCapacity"
                  mod="redesigned"
                  type="number"
                  :min="0"
                  placeholder="Введите сумму налоговых выплат"
                />
              </div>
            </div>
            <div class="create-projects__row">
              <div class="create-projects__wrapper-col--70">
                <p class="create-projects__label">Тип записи</p>
                <SelectSingleComponentCheckbox
                  placeholder="Выберите тип записи"
                  v-model="item.typeEntryId"
                  :options="getMpkProjectTypeEntries"
                  trackBy="text"
                  valueProp="id"
                  labelOptions="text"
                />
              </div>
            </div>
            <div class="create-projects__row">
              <div class="create-projects__wrapper-col--70">
                <p class="create-projects__label">Ссылка на дублирующий проект</p>
                <ComponentInput v-model="item.duplicateProjectLink" mod="redesigned" placeholder="Введите ссылку" />
              </div>
            </div>
            <div class="create-projects__row">
              <div class="create-projects__wrapper-col--70">
                <p class="create-projects__label">Ссылка на дублирующий проект, наименование</p>
                <ComponentInput
                  v-model="item.duplicateProjectLinkName"
                  mod="redesigned"
                  placeholder="Введите наименование"
                />
              </div>
            </div>
            <div class="create-projects__row">
              <div class="create-projects__wrapper-col--70">
                <p class="create-projects__label">Геотип объекта</p>
                <ComponentInput v-model="item.objectGeotype" mod="redesigned" placeholder="Введите геотип объекта" />
              </div>
            </div>
            <div class="create-projects__row">
              <div class="w-100">
                <p class="create-projects__label">Широта объекта в координатах WGS-84</p>
                <ComponentInput
                  v-model="item.objectLatitude"
                  mod="redesigned"
                  placeholder="Введите координаты"
                  type="number"
                />
              </div>
              <div class="w-100">
                <p class="create-projects__label">Долгота объекта в координатах WGS-84</p>
                <ComponentInput
                  v-model="item.objectLongitude"
                  mod="redesigned"
                  placeholder="Введите координаты"
                  type="number"
                />
              </div>
              <div class="w-100">
                <p class="create-projects__label">Набор координат линии объекта в координатах WGS-84</p>
                <ComponentInput v-model="item.lineCoordinates" mod="redesigned" placeholder="Введите координаты" />
              </div>
              <div class="w-100">
                <p class="create-projects__label">Набор координат полигона объекта в координатах WGS-84</p>
                <ComponentInput v-model="item.polygonCoordinates" mod="redesigned" placeholder="Введите координаты" />
              </div>
            </div>
            <div class="create-projects__row create-projects__row--start">
              <div class="w-100">
                <p class="create-projects__label">Каталог-источник</p>
                <ComponentInput v-model="item.catalogNumber" mod="redesigned" placeholder="Введите каталог-источник" />
              </div>
              <div class="w-100">
                <p class="create-projects__label">Код во внешнем источнике</p>
                <ComponentInput v-model="item.ehdId" mod="redesigned" placeholder="Введите код" type="number" />
              </div>
            </div>
          </div>
          <div class="create-projects__row create-projects__row--start">
            <div class="create-projects__wrapper-col--50">
              <p class="create-projects__label">Дата создания</p>
              <DateComponent v-model="item.createDate" :clearable="false" modClass="redesigned" dateIcon />
            </div>
          </div>
          <div v-if="!isProjectFromEnd" class="create-projects__row create-projects__row--start">
            <div class="w-100">
              <p class="create-projects__label">Проблема (комментарий)</p>
              <ComponentInput
                v-model="item.comment"
                type="textarea"
                mod="redesigned"
                placeholder="Введите комментарий"
              />
            </div>
          </div>
          <div v-if="!isProjectFromEnd" class="create-projects__row">
            <div class="create-projects__wrapper-col--70">
              <p class="create-projects__label">Ссылка на портал МПК</p>
              <ComponentInput v-model="item.portalMpkUrl" mod="redesigned" placeholder="Введите ссылку" />
            </div>
          </div>

          <div class="create-projects__row" v-if="isKNR || !isProjectFromEnd">
            <div class="w-100">
              <p class="create-projects__label">Подробнее</p>
              <ComponentInput v-model="item.details" type="textarea" mod="redesigned" />
            </div>
          </div>
        </div>

        <div class="create-projects__row" v-if="isKNR || !isProjectFromEnd">
          <div class="w-100">
            <p class="create-projects__label">Обсуждение на межгосударственных мероприятиях</p>
            <div v-if="!item.discussionEvents || item.discussionEvents.length === 0">Мероприятия не указаны</div>
            <div v-else class="discussion-events">
              <div v-for="(event, index) in item.discussionEvents" :key="index" class="discussion-events__row">
                <div class="discussion-events__date">
                  <DateComponent
                    v-model="event.eventDate"
                    :clearable="true"
                    placeholder="Дата мероприятия"
                    modClass="redesigned"
                    required
                  />
                </div>
                <div class="discussion-events__name">
                  <ComponentInput v-model="event.name" placeholder="Название мероприятия" mod="redesigned" required />
                </div>
                <div class="discussion-events__file">
                  <FileUpload
                    width="100%"
                    :entity="event"
                    @deleteFile="removeEventFile($event)"
                    required
                    propName="file"
                    :entityIndex="index"
                    @uploaded="fileEventUploaded"
                  />
                </div>
                <div class="discussion-events__delete">
                  <IconComponent @click="deleteEvent(index)" name="delete" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="isKNR || !isProjectFromEnd" class="create-project__row create-project__row--center event-btn">
          <ButtonComponent mod="blue-color" @click="addEvent()">Добавить поле</ButtonComponent>
        </div>
        <div v-if="!isProjectFromEnd" class="create-projects__row">
          <CheckboxInput
            v-model="item.isFoivReviewed"
            label="Рассмотрено ФОИВ"
            :disabled="!item.isReviewFoivAvailable && item.fullRights"
          />
        </div>
        <div v-if="!isProjectFromEnd" class="create-projects__row">
          <CheckboxInput
            v-model="item.needUpdating"
            label="Требуется актуализация"
            :disabled="!item.fullRights && !isCurator"
          />
        </div>

        <div class="create-projects__row">
          <ButtonComponent
            mod="gradient-bg"
            v-on:click="createChat"
            v-if="item.foivCuratorId && !chatExists && item.fullRights"
            >Отправить уведомление</ButtonComponent
          >
          <ButtonComponent mod="gradient-bg" v-on:click="gotoChat" v-if="item.foivCuratorId && chatExists"
            >Перейти к чату</ButtonComponent
          >
        </div>

        <div class="create-projects__row">
          <ButtonComponent mod="gradient-bg" v-on:click="save">Сохранить</ButtonComponent>
          <ButtonComponent mod="blue-color" v-on:click="close">Отмена</ButtonComponent>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex';
  import { useVuelidate } from '@vuelidate/core';
  import moment from 'moment';

  import ComponentInput from '@/common/components/ComponentInput.vue';
  import DateComponent from '@/common/components/DateComponent/DateComponent.vue';
  import FileUpload from '@/common/components/FileUpload.vue';
  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import CheckboxInput from '@/common/components/redesigned/CheckboxInput.vue';
  import SelectMultiComponentCheckbox from '@/common/components/redesigned/SelectRedesigned/SelectMultiComponentCheckbox.vue';
  import SelectSingleComponentCheckbox from '@/common/components/redesigned/SelectRedesigned/SelectSingleComponentCheckbox.vue';
  import Constants from '@/common/constants';
  import security from '@/common/mixins/security';
  import IconComponent from '@/common/ui/IconComponent.vue';
  import Utils from '@/common/utils';

  import Loader from '@/components/Loader.vue';

  import API_ORG from '@/modules/admin/api/organization';
  import API_COMMISSION from '@/modules/mpk/api/commission';
  import SumTooltip from '@/modules/mpkProject/components/SumTooltip.vue';
  import API_NSI from '@/modules/nsi/api/nsi';

  import API from '../api/index';
  import { MPK_PROJECT_ACTIONS_NAME, MPK_PROJECT_GETTERS_NAME } from '../store/mpkProject/name';

  import { DIRECTIVES_ACTIONS_NAME, DIRECTIVES_GETTERS_NAME } from '@/store/directives';

  const PERMISSIONS = {
    create: Constants.Permissions.MpkProjectCreate,
    edit: Constants.Permissions.MpkProjectEdit,
  };

  export default {
    name: 'EditProjectCard',
    components: {
      CheckboxInput,
      SumTooltip,
      Loader,
      ButtonComponent,
      ComponentInput,
      IconComponent,
      FileUpload,
      DateComponent,
      SelectSingleComponentCheckbox,
      SelectMultiComponentCheckbox,
    },
    data() {
      return {
        isLoading: true,
        projectId: this.$route.params.id,
        item: {},
        statuses: [],
        industries: [],
        countries: [],
        russianRegions: [],
        chinaRegions: [],
        mpkCommission: [],
        purposes: [],
        participantsDomestic: [],
        foivs: [],
        createInputCount: 1,
        inputsArr: [{ id: 1 }],
        chats: [],
        isCurator: false,
        plannedYearStartInvStage: null,
        plannedYearEndInvStage: null,
        plannedYearStartOpStage: null,
        plannedYearDesignCapacity: null,
        projectPurposes: [],
        projectCountries: [],
        isProjectFromEnd: false,
        showMore: false,
      };
    },
    mixins: [security],
    async created() {
      const permission = Number(this.projectId) === 0 ? PERMISSIONS.create : PERMISSIONS.edit;
      const isAllowed = await this.checkPermissionAndRedirect(permission);
      if (!isAllowed) return;

      this.loadCard();
      this.loadDictionaries();
      this.loadOtherDictionaries();
    },
    computed: {
      ...mapGetters({
        getMpkProjectDepartments: MPK_PROJECT_GETTERS_NAME.getMpkProjectDepartments,
        getMpkProjectMinRoles: MPK_PROJECT_GETTERS_NAME.getMpkProjectMinRoles,
        getMpkListProjects: MPK_PROJECT_GETTERS_NAME.getMpkListProjects,

        getMpkProjectSupportMeasures: MPK_PROJECT_GETTERS_NAME.getMpkProjectSupportMeasures,
        getMpkProjectCategories: MPK_PROJECT_GETTERS_NAME.getMpkProjectCategories,
        getMpkProjectTypeEntries: MPK_PROJECT_GETTERS_NAME.getMpkProjectTypeEntries,
        regionsList: DIRECTIVES_GETTERS_NAME.getRegionsSearchIdList,
        chinaProvincesList: DIRECTIVES_GETTERS_NAME.getChinaProvincesList,
      }),
      isKNR() {
        if (this.projectCountries.length === 0) {
          return false;
        }
        return this.projectCountries.includes(Constants.countryKNR);
      },
      isChina() {
        if (this.projectCountries.length === 0) {
          return false;
        }
        return this.projectCountries.includes(Constants.countryKNR);
      },
      isRussia() {
        if (this.projectCountries.length === 0) {
          return false;
        }
        return this.projectCountries.includes(Constants.countryRussiaId);
      },
      chatExists() {
        return this.item.foivCuratorId && this.chats[this.item.foivCuratorId] > 0;
      },
      projectListCountries: {
        get() {
          return this.projectCountries;
        },
        set(value) {
          this.projectCountries = value.map((id) => Number(id));
        },
      },
      allRelatedCountryIds() {
        const ids = [...this.projectCountries];
        if (this.item.partnerCountryId) {
          ids.push(this.item.partnerCountryId);
        }
        return [...new Set(ids)];
      },
    },
    watch: {
      allRelatedCountryIds: {
        handler(newIds, oldIds) {
          if (!newIds || newIds.length === 0) {
            this.mpkCommission = [];
            this.item.mpkComissionId = null;
            return;
          }
          const hadCountriesBefore = oldIds && oldIds.length > 0;
          const countriesWereRemoved = hadCountriesBefore && oldIds.some((id) => !newIds.includes(id));
          this.loadMpkCommissions(newIds, countriesWereRemoved);
        },
        deep: true,
      },
      isChina(newVal) {
        if (!newVal) {
          this.item.regionOfChinaId = null;
        }
      },
      isRussia(newVal) {
        if (!newVal) {
          this.item.regionOfRussiaId = null;
        }
      },
    },
    methods: {
      ...mapActions({
        getMpkProjectDepartment: MPK_PROJECT_ACTIONS_NAME.getMpkProjectDepartment,
        getMpkProjectMinRole: MPK_PROJECT_ACTIONS_NAME.getMpkProjectMinRole,
        getMpkProjectList: MPK_PROJECT_ACTIONS_NAME.getMpkProjectList,
        getMpkProjectSupportMeasure: MPK_PROJECT_ACTIONS_NAME.getMpkProjectSupportMeasure,
        getMpkProjectCategoryList: MPK_PROJECT_ACTIONS_NAME.getMpkProjectCategoryList,
        getMpkProjectTypeEntry: MPK_PROJECT_ACTIONS_NAME.getMpkProjectTypeEntry,
        getRegionsSearchId: DIRECTIVES_ACTIONS_NAME.getRegionsSearchId,
        getChinaProvinces: DIRECTIVES_ACTIONS_NAME.getChinaProvinces,
      }),
      loadCard() {
        this.isLoading = true;
        if (this.projectId == 0) {
          this.item.fundingAmounts = [];
          this.item.fundingAmounts.push({ year: '', amount: '' });

          // if (this.$route.query && this.$route.query.countryId > 0) {
          //   this.item.countryId = this.$route.query.countryId;
          // }

          this.checkPermission(Constants.Permissions.MpkProjectFoivReview).then((response) => {
            this.item.fullRights = !response.data;
          });
          this.isLoading = false;
        } else {
          API.find(this.projectId)
            .then((response) => {
              this.item = response.data;
              if (!this.item.canEdit) {
                Constants.alert.fire(
                  'Недостаточно прав',
                  'У вас недостаточно прав для просмотра данных проекта',
                  'error',
                );
                this.$router.push({ name: 'Projects', query: this.$route.query });
              } else {
                this.isProjectFromEnd = response.data.fromEhd;
                this.item.startMonthYear = moment(this.item.startMonthYear).format('YYYY-MM');
                this.item.endMonthYear = moment(this.item.endMonthYear).format('YYYY-MM');
                this.projectCountries = this.item.projectCountries.map(({ countryId }) => countryId);
                this.projectPurposes = this.item.projectPurposes.map(({ purposeId }) => purposeId);
                this.plannedYearStartInvStage = this.item.plannedYearStartInvStage;
                this.plannedYearEndInvStage = this.item.plannedYearEndInvStage;
                this.plannedYearStartOpStage = this.item.plannedYearStartOpStage;
                this.plannedYearDesignCapacity = this.item.plannedYearDesignCapacity;

                if (!this.item.fundingAmounts || this.item.fundingAmounts.length === 0) {
                  this.item.fundingAmounts = [];
                  this.item.fundingAmounts.push({ year: '', amount: '' });
                } else {
                  this.item.fundingAmounts = JSON.parse(this.item.fundingAmount);
                }
              }
            })
            .finally(() => {
              this.isLoading = false;
            });
          API.getChats(this.projectId).then((res) => {
            if (res && res.data) {
              this.chats = res.data;
            }
          });
        }
        let profile = this.$store.state.auth?.oidc?.profile;
        if (profile == null) profile = JSON.parse(localStorage.getItem('userProfileData'));
        this.isCurator = profile?.roleIds.includes(2);
      },
      // мпк
      loadMpkCommissions(countriesIds, checkCurrentSelection = false) {
        const request = {
          shortFormat: true,
          hasParent: false,
          isDeleted: false,
          countryIds: countriesIds,
        };

        API_COMMISSION.search(request).then((response) => {
          if (response.data) {
            this.mpkCommission = response.data.items.map((o) => {
              return { text: o.name, id: o.id };
            });
            if (checkCurrentSelection && this.item.mpkComissionId) {
              const currentId = Number(this.item.mpkComissionId);
              const isStillValid = this.mpkCommission.some((m) => Number(m.id) === currentId);
              if (!isStillValid) {
                this.item.mpkComissionId = null;
              }
            }
          }
        });
      },
      loadDictionaries() {
        let request = { pageNumber: 1, pageSize: 100000 };
        //страны
        Utils.loadSelectOptions('countryList', this.countries);
        //отрасли
        API_NSI.search('NsiIndustry', request).then((response) => {
          if (response.data) {
            this.industries = response.data.items.map((o) => {
              return { text: o.name, id: o.id };
            });
          }
        });
        //цели
        API_NSI.search('MpkProjectPurpose', request).then((response) => {
          if (response.data) {
            this.purposes = response.data.items.map((o) => {
              return { text: o.name, id: o.id };
            });
          }
        });
        Utils.loadSelectOptions('mpkProjectStatusList', this.statuses);

        request = { pageNumber: 1, pageSize: 0 };
        API_ORG.searchShortFormat(request).then((response) => {
          if (response.data) {
            this.participantsDomestic = response.data.items.map((o) => {
              return { text: o.name, id: o.id };
            });
          }
        });
        request = { pageNumber: 1, pageSize: 0, filter: { typeIds: ['1'] } };
        API_ORG.searchShortFormat(request).then((res) => {
          this.foivs = res.data.items.map((x) => ({ id: x.id, text: x.name }));
        });
      },
      async loadOtherDictionaries() {
        // регионы России
        const regResponse = await this.getRegionsSearchId();
        if (regResponse.success) {
          this.russianRegions = this.regionsList.map(({ id, name }) => ({ id, text: name }));
        }
        // регионы китая
        const chinaRegionsResponse = await this.getChinaProvinces();
        if (chinaRegionsResponse.success) {
          this.chinaRegions = this.chinaProvincesList.map(({ id, name }) => ({ id, text: name }));
        }

        // ответственный департамент МЭР
        await this.getMpkProjectDepartment({ pageNumber: 1, pageSize: 0 });
        // Степень участия МЭР в проекте
        await this.getMpkProjectMinRole();
        // Перечень проекта
        await this.getMpkProjectList();
        // Меры поддержки
        await this.getMpkProjectSupportMeasure();
        // Наименование меры поддержки, в рамках которой ведется учет инвестиционных проектов
        await this.getMpkProjectCategoryList();
        // Тип записи
        await this.getMpkProjectTypeEntry();
      },
      fileEventUploaded(e) {
        this.item.discussionEvents[e.entityIndex].file = e.data;
        this.item.discussionEvents[e.entityIndex].fileId = e.data ? e.data.id : null;
      },
      removeEventFile(e) {
        const index = e.entityIndex;
        this.item.discussionEvents[index].file = null;
        this.item.discussionEvents[index].fileId = null;
      },
      addEvent() {
        if (!this.item.discussionEvents) this.item.discussionEvents = [];
        this.item.discussionEvents.unshift({});
      },
      deleteEvent(index) {
        this.item.discussionEvents.splice(index, 1);
      },
      createChat() {
        if (this.projectId > 0) {
          API.createChat({
            projectId: this.projectId,
            orgId: this.item.foivCuratorId,
          })
            .then((res) => {
              if (res && res.data && res.data.id) {
                this.$router.push({
                  name: 'Messenger',
                  params: { initialDialogId: res.data.id },
                });
              }
            })
            .catch(() => {
              Constants.alert.fire('Создание чата', Constants.commonError, 'error');
            });
        } else {
          Constants.alert.fire('Создание чата', 'Сохраните проект', 'info');
        }
      },
      gotoChat() {
        let chatId = this.chats[this.item.foivCuratorId];
        if (chatId > 0) {
          this.$router.push({
            name: 'Messenger',
            params: { initialDialogId: chatId },
          });
        }
      },
      save() {
        this.v$.$touch();
        if (this.v$.$invalid) {
          Constants.alert.fire('Ошибка', 'Проверьте правильность заполнения полей', 'error');
          return;
        }
        this.item.fundingAmount = JSON.stringify(this.item.fundingAmounts);
        if (
          this.item.startMonthYear &&
          this.item.startMonthYear.length > 0 &&
          this.item.startMonthYear != 'Invalid date'
        )
          this.item.startMonthYear = this.item.startMonthYear + '-01';
        else this.item.startMonthYear = null;

        if (this.item.endMonthYear && this.item.endMonthYear.length > 0 && this.item.endMonthYear != 'Invalid date')
          this.item.endMonthYear = this.item.endMonthYear + '-01';
        else this.item.endMonthYear = null;

        this.item.projectCountries = this.projectCountries.map((id) => ({ countryId: Number(id) }));
        this.item.projectPurposes = this.projectPurposes.map((id) => ({ purposeId: Number(id) }));
        if (this.item.discussionEvents) {
          this.item.discussionEvents = this.item.discussionEvents.filter((e) => e.name || e.eventDate || e.fileId);
        }
        this.item.plannedYearStartInvStage = this.plannedYearStartInvStage;
        this.item.plannedYearEndInvStage = this.plannedYearEndInvStage;
        this.item.plannedYearStartOpStage = this.plannedYearStartOpStage;
        this.item.plannedYearDesignCapacity = this.plannedYearDesignCapacity;

        const currentFormatDate = moment(new Date()).format(Constants.DATE_FORMATS['YYYY-MM-DD']);

        this.item.objectLatitude =
          this.item.objectLatitude !== '' && this.item.objectLatitude != null
            ? parseFloat(this.item.objectLatitude)
            : null;
        this.item.objectLongitude =
          this.item.objectLongitude !== '' && this.item.objectLongitude != null
            ? parseFloat(this.item.objectLongitude)
            : null;

        if (!this.isChina) this.item.regionOfChinaId = null;
        if (!this.isRussia) this.item.regionOfRussiaId = null;

        this.item.dateProjectStatus = this.item?.dateProjectStatus ?? currentFormatDate;
        this.item.createDate = this.item?.createDate ?? currentFormatDate;
        this.item.signatureDate = this.item?.signatureDate ?? currentFormatDate;

        API.update(this.item)
          .then((response) => {
            Constants.alert.fire('Сохранение', Constants.commonSuccess, 'success');
            if (response && response.data.id) {
              //this.$router.push({ name: 'EditProjectCard', params: { id: response.data.id, action: 'edit' } })
              this.$router.push({ name: 'Projects', query: this.$route.query });
            }
          })
          .catch(() => {
            Constants.alert.fire('Сохранение', Constants.commonError, 'error');
          });
      },
      close() {
        this.$router.push({ name: 'Projects', query: this.$route.query });
      },
      onShowMore() {
        this.showMore = !this.showMore;
      },
      /** @public */
      createInput() {
        this.createInputCount++;
        this.inputsArr.push({ id: this.createInputCount });
      },
    },
    setup: () => ({ v$: useVuelidate() }),
  };
</script>

<style lang="scss" scoped>
  @import '../styles/EditProjectCard.scss';

  .loader {
    width: 100%;
    display: flex;
    justify-content: center;
  }
</style>

<style lang="scss">
  .create-projects {
    textarea {
      max-height: 120px;
    }
  }
</style>
